export default {
  catalogProduct: 'catalog_product',
  catalogCategory: 'catalog_category',
  catalogNavigation: 'catalog_navigation',
  catalogProductRanking: 'catalog_product_ranking',
  catalogProductAttribute: 'catalog_product_attribute',
  catalogProductAttributeSet: 'catalog_product_attribute_set',
};
